(function ($) {
    $(document).ready(function () {
        // Set tab link as active on page load
        $(".who-navigation a:first").addClass("active");

        // Tabs
        $(".who-navigation a").on("click", function (e) {
            e.preventDefault();
            let currentLink = $(e.currentTarget);
            let myTarget = currentLink.attr("href");

            $(".who-navigation a").removeClass("active");
            currentLink.addClass("active");

            $(".who-tab-content").removeClass("active");
            $(myTarget).addClass("active");
        });

    });
})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/who-tabs.es6